import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Popup } from "@progress/kendo-react-popup";
import { label, notifyIcon, number, quote } from "../../config";
import { createTaskFromEmail, deleteEmail, restoreEmail, updateEmailDetails } from "../../shared/services/workflowEmails.service";
import { getNotification } from "../../utils/common";
import { onBlur, onFocus, onOpen } from "../../utils/kendo";
import { emailDeleteOptions } from "./tasks.constants";
import { openSidebar } from "./tasks.service";

/**
 *Used to render link task popup in email page
 * @author Sejal
 */
const LinkTaskPopup = ({ anchor, showLinkPopUp, setShowLinkPopUp, dataItem, gridData, setGridData, handleCancel }) => {
  const deleteRef = useRef(null);
  const blurTimeoutRef = useRef(null);
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const { myProjectId } = useSelector((state) => state.auth.user);

  const [ackChecked, setAckChecked] = useState(false);
  const [refChecked, setRefChecked] = useState(false);

  // Reset checkboxes when component unmounts
  React.useEffect(() => {
    return () => {
      setAckChecked(false);
      setRefChecked(false);
    };
  }, []);

  const onOpenPopup = () => {
    onOpen(deleteRef);
  };

  const onFocusPopup = () => {
    onFocus(blurTimeoutRef);
  };

  const onBlurPopup = () => {
    onBlur(blurTimeoutRef, hideOnBlur);
  };
  const hideOnBlur = () => {
    setShowLinkPopUp(false);
  };

  // Stop propagation for all clicks inside popup
  const handlePopupClick = (e) => {
    e.stopPropagation();
  };

  // Prevent default for checkbox
  const handleAckCheckbox = (e) => {
    e.stopPropagation();
    setAckChecked((prev) => !prev);
  };
  const handleRefCheckbox = (e) => {
    e.stopPropagation();
    setRefChecked((prev) => !prev);
  };

  /**
   * Link task
   * @author Sejal
   */
  const handleLinkTask = async () => {
    const data = {
      emailRefId: dataItem.id,
      emailRefType: dataItem.EmailType,
      sendReferenceMail: refChecked,
      sendAcknowledgementMail: ackChecked,
      userId: user.id,
    };
    const response = await dispatch(createTaskFromEmail(data));
    if (response) {
      setShowLinkPopUp(false);
      getNotification(label.TASK_LINKED_SUCCESSFULLY, notifyIcon.SUCCESS_ICON);
      dataItem.TaskId = response?.taskId;
      dataItem.ProjectTaskId = response?.projectTaskId;
      if (handleCancel) {
        handleCancel();
      }
      if (gridData?.length > number.ZERO) {
        const updatedGridData = gridData.map((item) => {
          if (item.id === dataItem.id) {
            return {
              ...item,
              TaskId: response.taskId,
              ProjectTaskId: response.projectTaskId,
            };
          }
          return item;
        });
        setGridData(updatedGridData);
      }
      openSidebar({ id: response.taskId, userId: user.id });
    }
  };

  return (
    <Popup anchor={anchor?.current} show={showLinkPopUp} onOpen={onOpenPopup} className={"dt-popup new-tab-pop-up-link text-center  "}>
      <div tabIndex={number.ZERO} ref={deleteRef} onFocus={onFocusPopup} onBlur={onBlurPopup} onClick={handlePopupClick}>
        <div className='link-task-popup p-3'>
          <div className='link-task-popup-title'>Send</div>
          <div className='link-task-popup-checkbox my-2'>
            <input type='checkbox' id='ack-email-checkbox' checked={ackChecked} onClick={handleAckCheckbox} />
            <label className='ack-email-checkbox font-weight-normal' htmlFor="ack-email-checkbox">Acknowledgement Email</label>
          </div>
          <div className='link-task-popup-checkbox'>
            <input type='checkbox' id='ref-email-checkbox' checked={refChecked} onClick={handleRefCheckbox} />
            <label className='ack-email-checkbox font-weight-normal' htmlFor="ref-email-checkbox">Reference Email</label>
          </div>
          <div className='d-flex justify-content-end mt-2'>
            <button className='btn btn-sm' onClick={handleLinkTask}>
              Link Task
            </button>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default LinkTaskPopup;
